const ROUTES = {
  LOGIN: "/login",
  SIGNUP: "/signup",
  CONVERSION_SETUP: "/conversion-setup/:id",
  EMAIL_VALIDATION: "/emailValidation",
  ANALYTICS_VIEW: "/analytics-view/:id",
  RESET_PASSWORD: "/resetPassword",
  CONFIRM_EMAIL_CHANGE: "/confirmEmailChange",
  SETTINGS: "/settings/:id",
  ADMINLOGIN:"/admin-login",
  ADMIN_TWO_FACTOR: "/admin-two-factor",
  RESET_ADMIN_PASSWORD: "/resetAdminPassword",
  ADMINDASHBOARD:"/admin-dashboard",
  USERS:"/users",
  ADMIN:"/admin",
  DELETEDUSERS:"/deleted-users",
  AUDITLOG:"/audit-log",
  CANCELLATIONFEEDBACK:"/cancellation-feedback",
  ONBOARDING_INSIGHTS:"/onboarding-insights",
  SIGNUP_JOURNEY:"/signup-journey",
  MEMBERS:"/members",
  HELP_INSTALLING_SKYDIVE: "/help/installing-skydive",


};


export default ROUTES;

/*
 * The Settings path, built the same way PublicRoutes REGISTERS it.
 *
 * ROUTES.SETTINGS is "/settings/:id", but that route is only registered with
 * the :id segment for a logged-in ADMIN. For a normal customer it is
 * registered as plain "/settings". Several links were building
 * "/settings/<siteId>" for everyone, which matches nothing for a customer -
 * clicking Upgrade from the playback date picker or the historical date
 * selector dropped the customer on a blank page reading "no_route_match".
 *
 * Anything linking to Settings must use this, so the link and the route can
 * never disagree again.
 */
export const settingsPath = (isAdminLoggedIn?: boolean, siteId?: string): string =>
  isAdminLoggedIn && siteId
    ? ROUTES.SETTINGS.replace(":id", siteId)
    : ROUTES.SETTINGS.replace("/:id", "");
